import { createApp } from 'vue'
import ToastNotification from '@/components/ToastNotification.vue'

export function showToast(message: string, duration: number = 3000) {
  // Создаем контейнер для уведомления
  const container = document.createElement('div')
  document.body.appendChild(container)

  // Создаем приложение Vue с компонентом уведомления
  const app = createApp(ToastNotification, {
    message,
    duration,
  })

  // Монтируем компонент
  app.mount(container)

  // Удаляем контейнер после завершения анимации
  setTimeout(() => {
    app.unmount()
    document.body.removeChild(container)
  }, duration + 500) // +500ms для завершения анимации
}
